import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="bg-orange-50 py-20" aria-labelledby="faq-title" data-id="element-62" data-mp="1he2wzy8t5mf4">
      <div className="mx-auto max-w-3xl px-4" data-id="element-63" data-mp="1cfjd03drykpe">
        <h2 id="faq-title" className="text-balance text-center text-3xl font-extrabold text-green-950 md:text-4xl" data-id="element-64" data-mp="1ccndiama3nyu">
          Frequently asked questions
        </h2>
        <div className="mt-10 space-y-3" data-id="element-65" data-mp="254grdvev7xcv">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className="overflow-hidden rounded-lg border border-stone-200 bg-white" data-id="element-66" data-mp="1v5hm8mtb6jum" data-mpi={index}>
                <h3 className="font-sans" data-id="element-67" data-mp="opyrpdu5fbcy">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-green-950 transition-colors duration-150 ease-out hover:bg-green-50 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-amber-400/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-68" data-mp="omt2zzpfmbhr">
                    <span data-id="element-69" data-mp="1fn2ge07ahesw">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-stone-500 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-70" data-mp="11x8u9pn658mv" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-71" data-mp="rx871sm6i8de">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-72" data-mp="ww1kxm5do1e3">
                      <p className="border-t border-stone-100 px-5 py-4 leading-relaxed text-stone-600 sm:px-6" data-id="element-73" data-mp="2pogc9e30gk97">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}